import type { TFunction } from 'i18next';

export interface SaleDialogSubtitleState {
  isLoading: boolean;
  isError: boolean;
  totalCount: number;
  closingCount: number;
}

/**
 * Single source of truth for the sale dialog's header subtitle across its
 * loading/error/empty/resolved states (sale-breakdown-not-accepted-units /
 * "Sale action in the offer workspace").
 */
export function getSaleDialogSubtitle(
  t: TFunction<'offers'>,
  state: SaleDialogSubtitleState,
): string {
  if (state.isLoading) return t('workspace.header.saleDialog.loadingPreview');
  if (state.isError) return t('workspace.header.saleDialog.previewError');
  if (state.totalCount === 0) return t('workspace.header.saleDialog.nothingToClose');
  return t('workspace.header.saleDialog.description', { count: state.closingCount });
}
